// @flow

import React, { type Node } from 'react';

import { useUniqueId } from '@tectonics/hooks';
import { useUserInputAsTextField } from '@tectonics/prs/user-input-values';
import { useUserInputValidationError, type UserInputValidationError } from '@tectonics/prs/validation';
import { useSubmitting } from '@tectonics/prs/submitting';
import { useFormHasBeenSent } from '@tectonics/prs/form-status';

import { TextField } from '../../../../atoms';
import { ErrorLabel } from '../../../../molecules/error-label';

export function FieldArgentineCompanyName(): Node {
  const inputId = useUniqueId();
  const formHasBeenSent = useFormHasBeenSent();
  const validationError = useUserInputValidationError('companyName');
  const submitting = useSubmitting();

  const [value, handleChange] = useUserInputAsTextField('companyName');

  return (
    <div data-test-name="company-name">
      <label htmlFor={inputId}>
        Nombre
      </label>

      <TextField
        id={inputId}
        value={value}
        onChange={handleChange}
        fashion={formHasBeenSent && validationError ? 'error' : null}
        readOnly={submitting}
        data-error={formHasBeenSent && validationError ? 'error' : null}
        name="company-name"
      />

      {formHasBeenSent && validationError && (
        <ValidationMessage validationError={validationError} />
      )}
    </div>
  );
}

type ValidationErrorProps = {|
  validationError: UserInputValidationError,
|};

function ValidationMessage({ validationError }: ValidationErrorProps): Node {
  switch(validationError.id){
    case 'empty':
      return <ErrorLabel>El nombre es requerido</ErrorLabel>;

    default:
      return <ErrorLabel>Nombre inválido</ErrorLabel>;
  }
}
